import { Avatar, Typography } from 'antd';
import { useSelector } from 'react-redux';
const { Title, Text } = Typography;
const Team = ({ item }) => {
  console.log(item);

  return (
    <div className="flex flex-col rounded p-4 py-2 bg-gray-50">
      {/* <Title level={5}>Team</Title> */}
      <Text>{item?.name}</Text>
      {/* <div className="flex items-center">
        Team Members:
        <Avatar.Group key={4}>
          <Avatar />
          <Avatar />
          <Avatar />
          <Avatar />
        </Avatar.Group>
      </div> */}
    </div>
  );
};

export default Team;
